
import React from "react";

const emotions = [
  {
    key: "love",
    emoji: "❤️",
    name: "Love",
    definition:
      "An emotion characterized by strong feelings of affection, with or without it being directed at any particular person — a state of being loving and compassionate towards things animate or inanimate. Often associated with the term Agape love.",
    accent: "#e63946"
  },
  {
    key: "gratitude",
    emoji: "🙏",
    name: "Gratitude",
    definition:
      "A feeling of thankfulness or appreciation for someone or something in your life, often accompanied by warmth, kindness, and a desire to reciprocate.",
    accent: "#f4a261"
  },
  {
    key: "joy",
    emoji: "😄",
    name: "Joy",
    definition:
      "A state of being that allows one to experience intense, long-lasting happiness and contentment with life.",
    accent: "#2a9d8f"
  },
  {
    key: "pride",
    emoji: "🏆",
    name: "Pride",
    definition:
      "A feeling of satisfaction and accomplishment in oneself, one's abilities, or others' achievements. Can be positive, motivating, and empowering — but should be balanced with humility and self-awareness to avoid arrogance.",
    accent: "#6c63ff"
  },
  {
    key: "surprise",
    emoji: "😲",
    name: "Surprise",
    definition:
      "A sudden and unexpected feeling caused by something unusual happening. Surprise can be positive or negative depending on the context.",
    accent: "#48cae4"
  },
  {
    key: "sadness",
    emoji: "😢",
    name: "Sadness",
    definition:
      "A natural emotion characterized by sorrow, disappointment, and despair. It can be activated by loss, rejection, failure, separation from loved ones, or unmet emotional needs.",
    accent: "#457b9d"
  },
  {
    key: "anger",
    emoji: "😠",
    name: "Anger",
    definition:
      "A normal emotional response when you believe you have been treated unfairly or have been hurt. Anger emerges when you feel threatened emotionally, physically, financially, or in other ways.",
    accent: "#c1121f"
  },
  {
    key: "disgust",
    emoji: "🤢",
    name: "Disgust",
    definition:
      "A strong feeling of revulsion or aversion towards something offensive. Can be triggered by smells, tastes, sounds, sights, touch, actions or appearances of people, or ideas.",
    accent: "#606c38"
  },
  {
    key: "fear",
    emoji: "😨",
    name: "Fear",
    definition:
      "An emotion arising when an individual perceives a threat or danger — real or imagined — causing physiological and psychological changes, often triggering a fight-flight-freeze response. It serves as a protective mechanism to alert us to potential harm.",
    accent: "#7b2d8b"
  }
];


export default function EmotionDefinition() {
  React.useEffect(() => {
    document.title = "Emotion Definitions";
    document.body.style.backgroundColor = "#F2F2F2";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <div className="container-fluid px-0">
      <div className="container-fluid py-3 mx-0" style={{ backgroundColor: '#33b2ea' }}>
        <h2 className="text-white">Emotion Definitions</h2>
      </div>
      <div className="container-fluid" style={{ maxWidth: 860, margin: '0 auto', padding: '2rem 1rem 4rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 20
        }}>
          {emotions.map((e) => (
            <div key={e.key} style={{
              background: "#fff",
              borderRadius: 16,
              padding: "1.5rem 1.25rem",
              boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
              display: "flex",
              flexDirection: "column",
              gap: 12,
              borderTop: `4px solid ${e.accent}`,
              transition: "transform 0.2s, box-shadow 0.2s"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 32 }}>{e.emoji}</span>
                <span style={{ fontSize: 19, fontWeight: 700, color: e.accent }}>{e.name}</span>
              </div>
              <p style={{ fontSize: 15, lineHeight: 1.65, color: "#444" }}>{e.definition}</p>
            </div>
          ))}
        </div>
      </div>
      <footer className="border border-bottom-0 border-start-0 fixed-bottom bg-white border-end-0 py-2" style={{ borderColor: "#32b1e8 !important", color: "#123868" }}>
        <div className="text-center">
          <span className="fw-bold">
            {new Date().getFullYear()} The Tea group. All Rights Reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
